// sizes based off https://tailwindcss.com/docs/responsive-design
export const SM_MIN_WIDTH: string = '640px';
